import React, { useState, useEffect } from 'react';
import background1 from '../../assets/images/background1.png';
import background2 from '../../assets/images/background2.png';
import background3 from '../../assets/images/background3.png';

const BACKGROUNDS = [background1, background2, background3];
const SLIDE_DURATION = 6000; // 6 seconds per slide

/**
 * BackgroundSlideshow — Low-opacity crossfading background images.
 * Loops seamlessly: background1 → background2 → background3 → background1...
 * Each image displays for 6s with a 1.5s CSS crossfade transition.
 *
 * @component
 * @returns {JSX.Element}
 */
function BackgroundSlideshow() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % BACKGROUNDS.length);
    }, SLIDE_DURATION);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-slideshow" aria-hidden="true">
      {BACKGROUNDS.map((bg, index) => (
        <div
          key={index}
          className={`bg-slideshow__slide ${index === currentIndex ? 'bg-slideshow__slide--active' : ''}`}
          style={{ backgroundImage: `url(${bg})` }}
        />
      ))}
      <div className="bg-slideshow__overlay" />
    </div>
  );
}

export default BackgroundSlideshow;
